import React from 'react'
import * as Styled from './AppPrompt.styles'

const appLink = {
  IOS_APP_DOWNLOAD: 'https://apps.apple.com/gb/app/argos/id370371087',
  GOOGLE_APP_DOWNLOAD: 'https://play.google.com/store/apps/details?id=com.homeretailgroup.argos.android&hl=en_GB',
}

const AppPrompt = () => (
  <div className='container'>
    <Styled.Main>
      <Styled.Logo
        src='https://media.4rgos.it/i/Argos/app-argos-prompt?h=38&w=28&qlt=50'
        data-test='image-argos-card'
        alt='Argos App Logo'
        responsive
        lazy
      />

      <Styled.Text>
        <Styled.Prompt as='h4'>Argos in the palm of your hand</Styled.Prompt>
        <Styled.Prompt>Tap our free app and start exploring</Styled.Prompt>
      </Styled.Text>

      <Styled.Links>
        <a href={appLink.IOS_APP_DOWNLOAD} data-test='link-app-iphone' rel='noreferrer' target='_blank'>
          <Styled.StoreLink
            width={135}
            qlt={80}
            store='apple'
            data-test='image-apple-app-store'
            src='https://media.4rgos.it/i/Argos/app-apple-prompt'
            alt='Download on the Apple App Store'
            lazy
          />
        </a>
        <a href={appLink.GOOGLE_APP_DOWNLOAD} data-test='link-app-android' rel='noreferrer' target='_blank'>
          <Styled.StoreLink
            width={135}
            qlt={80}
            store='google'
            data-test='image-google-play-store'
            src='https://media.4rgos.it/i/Argos/app-google-prompt'
            alt='Download on the Google Play Store'
            lazy
          />
        </a>
      </Styled.Links>
    </Styled.Main>
  </div>
)

export default AppPrompt
